import { AdminCapacityEmail } from '../views/index';
import { CapacityEmail } from '../dtos/index';
import { DATE_MDY } from '../../utils/date/date-parser';

export const ADMIN_CAPACITY_EMAIL_LIST_TABLE = (
	capacityEmailList: Array<CapacityEmail> = []
): Array<AdminCapacityEmail> => {
	let results: Array<AdminCapacityEmail> = [];
	try {
		if (capacityEmailList.length > 0) {
			capacityEmailList.map((email, index) => {
				let row = {} as AdminCapacityEmail;
				row.attachmentProgressed = false;
				row.availableInC4 = email.firstTruckCreatedAt || '';
				if (email.carrier != undefined && email.carrier != null) {
					row.carrierMC = email.carrier.mc;
					row.carrierName = email.carrier.businessName;
				} else {
					row.carrierMC = '';
					row.carrierName = '';
				}
				row.parserUsed = email.parsingAlgorithmUsed || '';
				row.recievedOn = new Date(DATE_MDY(email.receivedOn)) || null;
				if (
					email.reviewStatus === 'reviewed' &&
					email.parsedCapacityEmailReviewedAt != undefined &&
					email.parsedCapacityEmailReviewedAt != null
				) {
					row.reviewedAt = new Date(DATE_MDY(email.parsedCapacityEmailReviewedAt));
				} else {
					row.reviewedAt = null;
				}
				row.senderEmailAddress = email.emailAddress || '';
				row.truckCount = email.parsedTrucksCount || null;
				results.push(row);
			});
		}
	} catch (error) {
		console.log('ADMIN_CAPACITY_EMAIL_LIST_TABLE error: ', error);
	}

	return results;
};
